import React from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import { connect } from "react-redux";

const Answerer = (props) => {
  const { parameters, answerer_player_details } = props;
  const display_name = _.get(answerer_player_details, "display_name");
  const profile_image = _.get(answerer_player_details, "profile_image");

  const info_1 = _.get(
    parameters,
    "3_answerer.info_1",
    "The reader has selected..."
  );
  const info_2 = _.get(
    parameters,
    "3_answerer.info_2",
    "to answer the question!"
  );

  return (
    <div className="answerer">
      <h3>{info_1} </h3>
      <FluserUser display_name={display_name} profile_image={profile_image} />
      <h3>{info_2}</h3>
    </div>
  );
};

export default Answerer;
